<div class="container">
  <img
    class="video-preview"
    width="90"
    height="90"
    alt=""
    src="assets/images/telegram/preview-video.webp"
  />
  <button
    mat-mini-fab
    class="open-video"
    (click)="handleOpenVideo()"
  >
    <mat-icon>play_circle</mat-icon>
  </button>
</div>
